import { FC } from 'react';
import { Blacklist } from '../../components/Blacklist/Blacklist';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/store';
import { selectRoles, selectToken } from '../../store/reducers/AuthSlice';
import { NotFoundScreen } from '../NotFoundScreen';

interface Props {
  allowedRoles: string[];
}

export const BlacklistScreen: FC<Props> = ({ allowedRoles }) => {
  const token = useAppSelector(selectToken);
  const roles = useAppSelector(selectRoles);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!roles?.find((role) => allowedRoles?.includes(role))) {
    return <NotFoundScreen />;
  }

  return <Blacklist />;
};

BlacklistScreen.displayName = 'BlacklistScreen';
